import { initialState } from "./attachmentsContext";
import { TYPES } from "./attachmentsTypes";

export function AttachmentsReducer(state, action) {
  const { type, payload } = action;

  const setFileToView = () => {
    return {
      ...state,
      fileToView: payload,
    };
  };

  const setBlobLocalURL = () => {
    return {
      ...state,
      blobLocalURL: payload,
    };
  };

  const clear = () => initialState;

  const setStateReducerTypes = {
    [TYPES.SET_FILE_TO_VIEW]: setFileToView,
    [TYPES.SET_BLOB_LOCAL_URL]: setBlobLocalURL,
    [TYPES.SET_CLEAR]: clear,
  };

  return setStateReducerTypes[type]() || state;
}
